import { cacheSteps, cacheTips } from "@/mocks/homeData";
import SectionHeading from "./SectionHeading";

export default function CacheGuide() {
  return (
    <section id="cache" className="w-full bg-background-50 px-4 py-14 md:px-8 md:py-20">
      <div className="mx-auto max-w-6xl">
        <SectionHeading
          eyebrow="缓存视频"
          title="把想看的剧集缓存到手机，按这五步就好"
          description="缓存视频是从“在线看”到“离线看”之间最关键的一步。下面把整个过程拆成五步，配合右侧要点，基本一次就能学会。"
        />

        <div className="mt-9 grid grid-cols-1 gap-6 lg:grid-cols-[0.9fr_1.1fr] md:mt-12 md:gap-8">
          <div className="relative overflow-hidden rounded-lg border border-background-200 bg-background-100">
            <img
              src="https://readdy.ai/api/search-image?query=Soft%20warm%20studio%20photography%20of%20a%20smartphone%20standing%20on%20a%20clean%20beige%20surface%20with%20warm%20amber%20and%20rose%20accent%20lighting%2C%20minimal%20elegant%20product%20aesthetic%2C%20soft%20shadows%2C%20no%20readable%20text%2C%20calm%20modern%20composition%2C%20editorial%20quality&width=1200&height=1400&seq=hanjutv-cache-phone-02&orientation=portrait"
              alt="手机放在浅色台面上，用于演示把剧集缓存到本地的场景"
              className="h-56 w-full object-cover object-top md:h-full md:min-h-[420px]"
            />
            <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-foreground-950/80 to-transparent p-5">
              <p className="text-xs font-medium text-accent-300">小贴士</p>
              <p className="mt-1 text-sm font-semibold text-background-50">
                批量缓存建议连接 Wi-Fi，并预留足够存储空间
              </p>
            </div>
          </div>

          <div>
            <ol className="space-y-3">
              {cacheSteps.map((item) => (
                <li
                  key={item.step}
                  className="flex gap-4 rounded-lg border border-background-200 bg-background-100 p-4 transition-colors hover:border-primary-300 md:p-5"
                >
                  <span className="font-heading text-2xl font-black text-primary-300 md:text-3xl">
                    {item.step}
                  </span>
                  <span className="pt-1">
                    <span className="block font-heading text-base font-bold text-foreground-950 md:text-lg">
                      {item.title}
                    </span>
                    <span className="mt-1 block text-sm leading-relaxed text-foreground-600">
                      {item.desc}
                    </span>
                  </span>
                </li>
              ))}
            </ol>

            <div className="mt-5 rounded-lg bg-secondary-100 p-5 md:p-6">
              <h3 className="flex items-center gap-2 font-heading text-base font-bold text-secondary-900 md:text-lg">
                <span className="flex h-5 w-5 items-center justify-center">
                  <i className="ri-bookmark-3-line text-lg"></i>
                </span>
                缓存时容易忽略的几点
              </h3>
              <ul className="mt-4 grid grid-cols-1 gap-3 sm:grid-cols-2">
                {cacheTips.map((tip) => (
                  <li key={tip} className="flex gap-2.5 text-sm leading-relaxed text-foreground-700">
                    <span className="flex h-4 w-4 flex-shrink-0 items-center justify-center pt-0.5">
                      <i className="ri-checkbox-circle-line text-base text-secondary-600"></i>
                    </span>
                    {tip}
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}